// src/pages/ServicesPage/ServicesPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ServicesPage.module.css';

// Importing a wider range of icons for the expanded list
import { 
  FaCode, FaPaintBrush, FaUserTie, FaChartLine, 
  FaShareAlt, FaShoppingCart, FaCheckCircle, FaShieldAlt 
} from 'react-icons/fa';

const ServicesPage = () => {
  return (
    <div className={styles.servicesPage}>
      
      {/* 1. HERO SECTION */}
      <header className={styles.hero}>
        <h1 className={styles.heroTitle}>Comprehensive <span className={styles.teal}>Digital Solutions</span></h1>
        <p className={styles.heroSubtitle}>
          Nate~Anne provides end-to-end technical and creative support. We don't just build assets; we build the digital infrastructure your business needs to scale.
        </p>
      </header>

      {/* 2. EXPANDED SERVICES GRID */}
      <section className={styles.servicesGrid}>
        {/* Web Development */}
        <div className={styles.serviceCard}>
          <FaCode className={styles.serviceIcon} />
          <h3>Web Development</h3>
          <p>From Business Portfolios to complex Membership sites, we build high-performance React applications.</p>
          <ul>
            <li>Full-Stack Development</li>
            <li>Booking & Appointment Systems</li>
            <li>Mobile-First Optimization</li>
          </ul>
        </div>

        {/* E-commerce */}
        <div className={styles.serviceCard}>
          <FaShoppingCart className={styles.serviceIcon} />
          <h3>E-commerce Setup</h3>
          <p>Launch your online store with secure payment gateways and intuitive product management systems.</p>
          <ul>
            <li>Shopify & Custom Stores</li>
            <li>Inventory Integration</li>
            <li>Secure Checkout Flow</li>
          </ul>
        </div>

        {/* Branding & Graphic Design */}
        <div className={styles.serviceCard}>
          <FaPaintBrush className={styles.serviceIcon} />
          <h3>Graphic Design</h3>
          <p>Full branding kits including professional logos, business cards, and social media assets.</p>
          <ul>
            <li>Logo & Identity Design</li>
            <li>Marketing Materials</li>
            <li>UI/UX Design Systems</li>
          </ul>
        </div>

        {/* Social Media & Marketing */}
        <div className={styles.serviceCard}>
          <FaShareAlt className={styles.serviceIcon} />
          <h3>Social Media & Marketing</h3>
          <p>Strategic management and digital marketing to increase your brand's reach and engagement.</p>
          <ul>
            <li>Social Media Management</li>
            <li>Content Strategy</li>
            <li>Digital Marketing Ads</li>
          </ul>
        </div>

        {/* Virtual Assistant */}
        <div className={styles.serviceCard}>
          <FaUserTie className={styles.serviceIcon} />
          <h3>Virtual Assistant</h3>
          <p>Professional operational support to help business owners focus on core growth.</p>
          <ul>
            <li>Email & Schedule Management</li>
            <li>Data Entry & Research</li>
            <li>Customer Support</li>
          </ul>
        </div>

        {/* Strategy & Growth */}
        <div className={styles.serviceCard}>
          <FaChartLine className={styles.serviceIcon} />
          <h3>Digital Strategy</h3>
          <p>We analyze your current business website and create a roadmap for technical improvements.</p>
          <ul>
            <li>SEO & Performance Audits</li>
            <li>Conversion Optimization</li>
            <li>Scalability Planning</li>
          </ul>
        </div>
      </section>

      {/* 3. TRANSPARENT PROCESS SECTION */}
      <section className={styles.processSection}>
        <div className={styles.processHeader}>
          <h2 className={styles.sectionTitle}>A Fully Transparent Process</h2>
          <p>We eliminate technical mystery by providing a clear, step-by-step roadmap for every project.</p>
        </div>
        
        <div className={styles.processTimeline}>
          {[
            { num: "01", title: "Discovery", desc: "We gather your business goals, target audience, and functional requirements." },
            { num: "02", title: "Design", desc: "Visual mockups and brand assets are crafted and approved before coding starts." },
            { num: "03", title: "Development", desc: "We build your solution using modern tech stacks with frequent updates." },
            { num: "04", title: "Launch", desc: "Deployment to hosting and training on how to manage your new digital assets." }
          ].map((step, i) => (
            <div key={i} className={styles.processStep}>
              <span className={styles.stepNum}>{step.num}</span>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 4. WHY CHOOSE NATE~ANNE SECTION */}
      <section className={styles.trustSection}>
        <div className={styles.trustCard}>
          <FaCheckCircle className={styles.trustIcon} />
          <h3>Budget-Friendly Solutions</h3>
          <p>We offer flexible service tiers ranging from under R2000 to full-scale enterprise builds over R10000.</p>
        </div>
        <div className={styles.trustCard}>
          <FaShieldAlt className={styles.trustIcon} />
          <h3>Data & Privacy Consent</h3>
          <p>We prioritize your security and strictly follow data consent protocols for all business information.</p>
        </div>
      </section>

      {/* 5. FINAL CALL TO ACTION */}
      <section className={styles.cta}>
        <h2>Ready to build your next success story?</h2>
        <Link to="/contact" className={styles.ctaButton}>Start a Project</Link>
      </section>
    </div>
  );
};

export default ServicesPage;
